import { render, staticRenderFns } from "./PorletLabel.vue?vue&type=template&id=bf445aba&"
import script from "./PorletLabel.vue?vue&type=script&lang=js&"
export * from "./PorletLabel.vue?vue&type=script&lang=js&"
import style0 from "./PorletLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports